/**
 * Asynchronously loads the component for DashboardRoute
 */

import { lazyLoad } from 'utils/loadable';

export const DashboardRoute = lazyLoad(
  () => import('./index'),
  module => module.DashboardRoute,
);
